// WEB IMPLEMENTATION DESPITE NOT HAVING .web.tsx

import React, { useState, useRef } from 'react';
import { Interactable, Text, Icon, Image } from '@24i/nxg-sdk-quarks/src';
import getStyles from '@24i/nxg-sdk-smartott/src/components/ShareDropdown/styles';
import { useTheme } from '@24i/nxg-sdk-higgs/src';
import { ViewStyle } from 'react-native';
import useOutsideClick from '@24i/nxg-sdk-smartott/src/hooks/useOutsideClick';
import { useImage } from '@24i/nxg-sdk-gluons/src/context/ImageService';
import { ShareDropdownOption, ShareDropdownProps } from '../types';

const ShareDropdown = (props: ShareDropdownProps): JSX.Element => {
    const containerRef = useRef(null);
    const { options, closeDropdown } = props;
    const { theme } = useTheme();
    const { getImageSource } = useImage();
    const styles = getStyles(theme);
    useOutsideClick(containerRef, closeDropdown);

    const defaultShareOptions = (): ShareDropdownOption[] => [
        { title: 'Facebook', image: getImageSource('facebook') },
        { title: 'Twitter', image: getImageSource('twitter') },
        { title: 'Email link', icon: { iconFont: 'materialIcons', iconName: 'email' } },
        { title: 'Copy link', icon: { iconFont: 'materialIcons', iconName: 'link' } },
    ];

    const toRender = options || defaultShareOptions();
    const [hoveredIndex, setHoveredIndex] = useState<number>(-1);

    const getItemContainerStyles = (index: number): ViewStyle => {
        if (index === hoveredIndex) {
            return { ...styles.itemContainer, ...{ backgroundColor: theme.color.primary4 } };
        }

        return styles.itemContainer;
    };

    return (
        <Interactable style={styles.container} ref={containerRef}>
            {toRender.map((option: ShareDropdownOption, index) => (
                <Interactable
                    key={`share_dropdown_option${option.title})`}
                    style={getItemContainerStyles(index)}
                    onPress={() => (option.onPress ? option.onPress : closeDropdown())}
                    onMouseEnter={() => setHoveredIndex(index)}
                    onMouseLeave={() => setHoveredIndex(-1)}
                >
                    {option.image && (
                        <Image
                            source={{ uri: option.image }}
                            resizeMode="contain"
                            style={styles.optionImage}
                        />
                    )}
                    {option.icon && (
                        <Icon
                            name={option.icon.iconName}
                            font={option.icon?.iconFont}
                            color="white"
                            size={17}
                            style={{ marginRight: 16 }}
                        />
                    )}
                    <Text style={styles.text}>{option.title}</Text>
                </Interactable>
            ))}
        </Interactable>
    );
};

export default ShareDropdown;
